import {
  canSendDirectMessage,
  isExternalRecipientId,
} from '../../core/rules/messagingAccess';
import type { MessageParticipant } from '../../core/rules/messagingAccess';
import type { SendDirectMessageInput } from '../../core/models/DirectMessage';
import type { IMessagingAdapter } from '../../adapters/messaging/IMessagingAdapter';

export async function sendDirectMessage(
  adapter: IMessagingAdapter,
  sender: MessageParticipant,
  recipient: MessageParticipant,
  payload: {
    subject: string;
    body: string;
    inApp: boolean;
    email: boolean;
    draftId?: string;
  },
) {
  if (!canSendDirectMessage(sender, recipient)) {
    throw new Error('Cannot send message to this user.');
  }

  const external = isExternalRecipientId(recipient.id);
  const inApp = external ? false : payload.inApp;
  const email = external ? true : payload.email;

  if (!inApp && !email) {
    throw new Error('Select at least one delivery channel.');
  }
  if (email && !recipient.email) {
    throw new Error('Recipient has no email on file.');
  }

  const input: SendDirectMessageInput & { draftId?: string } = {
    fromUserId: sender.id!,
    fromName: sender.name ?? '',
    toUserId: recipient.id!,
    toName: recipient.name ?? '',
    toEmail: recipient.email,
    subject: payload.subject.trim(),
    body: payload.body.trim(),
    inApp,
    email,
    draftId: payload.draftId,
  };

  return adapter.send(input);
}
